// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 공통 컴포넌트 스타일 */

/* 버튼 스타일 */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-sm) var(--spacing-md);
  border: 1px solid transparent;
  border-radius: var(--border-radius);
  font-size: var(--font-sm);
  font-weight: var(--font-medium);
  line-height: 1.5;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  transition: all var(--transition-base);
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
}

.btn:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.25);
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

/* 버튼 크기 */
.btn-sm {
  padding: var(--spacing-xs) var(--spacing-sm);
  font-size: var(--font-xs);
}

.btn-lg {
  padding: var(--spacing-md) var(--spacing-lg);
  font-size: var(--font-lg);
}

/* 버튼 색상 */
.btn-primary {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  color: var(--white);
}

.btn-primary:hover:not(:disabled) {
  background-color: var(--primary-hover);
  border-color: var(--primary-hover);
  box-shadow: var(--shadow-md);
}

.btn-secondary {
  background-color: var(--secondary-color);
  border-color: var(--secondary-color);
  color: var(--white);
}

.btn-secondary:hover:not(:disabled) {
  background-color: var(--secondary-hover);
  border-color: var(--secondary-hover);
  box-shadow: var(--shadow-md);
}

.btn-success {
  background-color: var(--success-color);
  border-color: var(--success-color);
  color: var(--white);
}

.btn-success:hover:not(:disabled) {
  background-color: var(--success-hover);
  border-color: var(--success-hover);
  box-shadow: var(--shadow-md);
}

.btn-danger {
  background-color: var(--danger-color);
  border-color: var(--danger-color);
  color: var(--white);
}

.btn-danger:hover:not(:disabled) {
  background-color: var(--danger-hover);
  border-color: var(--danger-hover);
  box-shadow: var(--shadow-md);
}

.btn-outline-primary {
  background-color: transparent;
  border-color: var(--primary-color);
  color: var(--primary-color);
}

.btn-outline-primary:hover:not(:disabled) {
  background-color: var(--primary-color);
  color: var(--white);
}

.btn-warning {
  background-color: #ffc107;
  border-color: #ffc107;
  color: #212529;
}

.btn-warning:hover:not(:disabled) {
  background-color: #e0a800;
  border-color: #d39e00;
  box-shadow: var(--shadow-md);
}

/* 폼 요소 */
.form-control {
  display: block;
  width: 100%;
  padding: var(--spacing-sm) var(--spacing-md);
  font-size: var(--font-base);
  line-height: 1.5;
  color: var(--text-primary);
  background-color: var(--white);
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius);
  transition: border-color var(--transition-base), box-shadow var(--transition-base);
}

.form-control:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.25);
}

.form-control:disabled {
  background-color: var(--gray-50);
  color: var(--gray-500);
  cursor: not-allowed;
}

.form-control.error {
  border-color: var(--danger-color);
  box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.25);
}

.form-label {
  display: block;
  margin-bottom: var(--spacing-xs);
  font-weight: var(--font-medium);
  color: var(--text-primary);
  font-size: var(--font-sm);
}

.form-label.required::after {
  content: ' *';
  color: var(--danger-color);
}

/* 카드 */
.card {
  background-color: var(--white);
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
}

.card-header {
  padding: var(--spacing-md) var(--spacing-lg);
  background-color: var(--gray-50);
  border-bottom: 1px solid var(--border-color);
  font-weight: var(--font-semibold);
  color: var(--text-primary);
}

.card-body {
  padding: var(--spacing-lg);
}

.card-footer {
  padding: var(--spacing-md) var(--spacing-lg);
  background-color: var(--gray-50);
  border-top: 1px solid var(--border-color);
}

/* 알림 메시지 */
.alert {
  padding: var(--spacing-md);
  margin-bottom: var(--spacing-md);
  border: 1px solid transparent;
  border-radius: var(--border-radius);
  font-weight: var(--font-medium);
}

.alert-success {
  color: #155724;
  background-color: var(--success-light);
  border-color: var(--success-border);
}

.alert-danger {
  color: #721c24;
  background-color: var(--danger-light);
  border-color: var(--danger-border);
}

.alert-warning {
  color: #856404;
  background-color: var(--warning-light);
  border-color: var(--warning-border);
}

.alert-info {
  color: #0c5460;
  background-color: var(--info-light);
  border-color: var(--info-border);
}


/* 테이블 */
.table {
  width: 100%;
  border-collapse: collapse;
  background-color: var(--white);
  border-radius: var(--border-radius-lg);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
}

.table th,
.table td {
  padding: var(--spacing-md);
  text-align: left;
  border-bottom: 1px solid var(--border-color);
}

.table th {
  background-color: var(--gray-50);
  font-weight: var(--font-semibold);
  color: var(--text-primary);
  font-size: var(--font-sm);
}

.table tbody tr:hover {
  background-color: var(--gray-50);
}

.table tbody tr:nth-child(even) {
  background-color: #fafafa;
}

.table tbody tr:nth-child(even):hover {
  background-color: #f0f0f0;
}


/* 뒤로가기 버튼 (공통) */
.back-btn,
.close-salary-view-btn {
  background: #6c757d;
  color: white;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  flex-grow: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease;
}

.back-btn:hover,
.close-salary-view-btn:hover {
  background: #5a6268;
}

/* 에러 컨테이너 */
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-xl);
  gap: var(--spacing-md);
}

/* 반응형 유틸리티 */
@media (max-width: 768px) {
  .btn {
    padding: var(--spacing-sm);
    font-size: var(--font-xs);
  }
  
  .btn-lg {
    padding: var(--spacing-sm) var(--spacing-md);
    font-size: var(--font-sm);
  }
  
  .card-body {
    padding: var(--spacing-md);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/components.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB,WAAW;AACX;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,4CAA4C;EAC5C,6BAA6B;EAC7B,mCAAmC;EACnC,yBAAyB;EACzB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,sCAAsC;EACtC,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,UAAU;AACV;EACE,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,sCAAsC;EACtC,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA,SAAS;AACT;EACE,cAAc;EACd,WAAW;EACX,4CAA4C;EAC5C,2BAA2B;EAC3B,gBAAgB;EAChB,0BAA0B;EAC1B,8BAA8B;EAC9B,qCAAqC;EACrC,mCAAmC;EACnC,kFAAkF;AACpF;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,+CAA+C;AACjD;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,+BAA+B;EAC/B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA,OAAO;AACP;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,sCAAsC;EACtC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,gCAAgC;EAChC,4CAA4C;EAC5C,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4CAA4C;EAC5C,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA,WAAW;AACX;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,6BAA6B;EAC7B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,gCAAgC;AAClC;;;AAGA,QAAQ;AACR;EACE,WAAW;EACX,yBAAyB;EACzB,8BAA8B;EAC9B,sCAAsC;EACtC,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;EAEE,0BAA0B;EAC1B,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA,iBAAiB;AACjB;;EAEE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA,aAAa;AACb;EACE;IACE,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;IACE,4CAA4C;IAC5C,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* 공통 컴포넌트 스타일 */\r\n\r\n/* 버튼 스타일 */\r\n.btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: var(--spacing-sm);\r\n  padding: var(--spacing-sm) var(--spacing-md);\r\n  border: 1px solid transparent;\r\n  border-radius: var(--border-radius);\r\n  font-size: var(--font-sm);\r\n  font-weight: var(--font-medium);\r\n  line-height: 1.5;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  transition: all var(--transition-base);\r\n  user-select: none;\r\n  white-space: nowrap;\r\n}\r\n\r\n.btn:focus {\r\n  outline: none;\r\n  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.25);\r\n}\r\n\r\n.btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n  pointer-events: none;\r\n}\r\n\r\n/* 버튼 크기 */\r\n.btn-sm {\r\n  padding: var(--spacing-xs) var(--spacing-sm);\r\n  font-size: var(--font-xs);\r\n}\r\n\r\n.btn-lg {\r\n  padding: var(--spacing-md) var(--spacing-lg);\r\n  font-size: var(--font-lg);\r\n}\r\n\r\n/* 버튼 색상 */\r\n.btn-primary {\r\n  background-color: var(--primary-color);\r\n  border-color: var(--primary-color);\r\n  color: var(--white);\r\n}\r\n\r\n.btn-primary:hover:not(:disabled) {\r\n  background-color: var(--primary-hover);\r\n  border-color: var(--primary-hover);\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n.btn-secondary {\r\n  background-color: var(--secondary-color);\r\n  border-color: var(--secondary-color);\r\n  color: var(--white);\r\n}\r\n\r\n.btn-secondary:hover:not(:disabled) {\r\n  background-color: var(--secondary-hover);\r\n  border-color: var(--secondary-hover);\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n.btn-success {\r\n  background-color: var(--success-color);\r\n  border-color: var(--success-color);\r\n  color: var(--white);\r\n}\r\n\r\n.btn-success:hover:not(:disabled) {\r\n  background-color: var(--success-hover);\r\n  border-color: var(--success-hover);\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n.btn-danger {\r\n  background-color: var(--danger-color);\r\n  border-color: var(--danger-color);\r\n  color: var(--white);\r\n}\r\n\r\n.btn-danger:hover:not(:disabled) {\r\n  background-color: var(--danger-hover);\r\n  border-color: var(--danger-hover);\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n.btn-outline-primary {\r\n  background-color: transparent;\r\n  border-color: var(--primary-color);\r\n  color: var(--primary-color);\r\n}\r\n\r\n.btn-outline-primary:hover:not(:disabled) {\r\n  background-color: var(--primary-color);\r\n  color: var(--white);\r\n}\r\n\r\n.btn-warning {\r\n  background-color: #ffc107;\r\n  border-color: #ffc107;\r\n  color: #212529;\r\n}\r\n\r\n.btn-warning:hover:not(:disabled) {\r\n  background-color: #e0a800;\r\n  border-color: #d39e00;\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n/* 폼 요소 */\r\n.form-control {\r\n  display: block;\r\n  width: 100%;\r\n  padding: var(--spacing-sm) var(--spacing-md);\r\n  font-size: var(--font-base);\r\n  line-height: 1.5;\r\n  color: var(--text-primary);\r\n  background-color: var(--white);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: var(--border-radius);\r\n  transition: border-color var(--transition-base), box-shadow var(--transition-base);\r\n}\r\n\r\n.form-control:focus {\r\n  outline: none;\r\n  border-color: var(--primary-color);\r\n  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.25);\r\n}\r\n\r\n.form-control:disabled {\r\n  background-color: var(--gray-50);\r\n  color: var(--gray-500);\r\n  cursor: not-allowed;\r\n}\r\n\r\n.form-control.error {\r\n  border-color: var(--danger-color);\r\n  box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.25);\r\n}\r\n\r\n.form-label {\r\n  display: block;\r\n  margin-bottom: var(--spacing-xs);\r\n  font-weight: var(--font-medium);\r\n  color: var(--text-primary);\r\n  font-size: var(--font-sm);\r\n}\r\n\r\n.form-label.required::after {\r\n  content: ' *';\r\n  color: var(--danger-color);\r\n}\r\n\r\n/* 카드 */\r\n.card {\r\n  background-color: var(--white);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: var(--border-radius-lg);\r\n  box-shadow: var(--shadow-sm);\r\n  overflow: hidden;\r\n}\r\n\r\n.card-header {\r\n  padding: var(--spacing-md) var(--spacing-lg);\r\n  background-color: var(--gray-50);\r\n  border-bottom: 1px solid var(--border-color);\r\n  font-weight: var(--font-semibold);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.card-body {\r\n  padding: var(--spacing-lg);\r\n}\r\n\r\n.card-footer {\r\n  padding: var(--spacing-md) var(--spacing-lg);\r\n  background-color: var(--gray-50);\r\n  border-top: 1px solid var(--border-color);\r\n}\r\n\r\n/* 알림 메시지 */\r\n.alert {\r\n  padding: var(--spacing-md);\r\n  margin-bottom: var(--spacing-md);\r\n  border: 1px solid transparent;\r\n  border-radius: var(--border-radius);\r\n  font-weight: var(--font-medium);\r\n}\r\n\r\n.alert-success {\r\n  color: #155724;\r\n  background-color: var(--success-light);\r\n  border-color: var(--success-border);\r\n}\r\n\r\n.alert-danger {\r\n  color: #721c24;\r\n  background-color: var(--danger-light);\r\n  border-color: var(--danger-border);\r\n}\r\n\r\n.alert-warning {\r\n  color: #856404;\r\n  background-color: var(--warning-light);\r\n  border-color: var(--warning-border);\r\n}\r\n\r\n.alert-info {\r\n  color: #0c5460;\r\n  background-color: var(--info-light);\r\n  border-color: var(--info-border);\r\n}\r\n\r\n\r\n/* 테이블 */\r\n.table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  background-color: var(--white);\r\n  border-radius: var(--border-radius-lg);\r\n  overflow: hidden;\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.table th,\r\n.table td {\r\n  padding: var(--spacing-md);\r\n  text-align: left;\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.table th {\r\n  background-color: var(--gray-50);\r\n  font-weight: var(--font-semibold);\r\n  color: var(--text-primary);\r\n  font-size: var(--font-sm);\r\n}\r\n\r\n.table tbody tr:hover {\r\n  background-color: var(--gray-50);\r\n}\r\n\r\n.table tbody tr:nth-child(even) {\r\n  background-color: #fafafa;\r\n}\r\n\r\n.table tbody tr:nth-child(even):hover {\r\n  background-color: #f0f0f0;\r\n}\r\n\r\n\r\n/* 뒤로가기 버튼 (공통) */\r\n.back-btn,\r\n.close-salary-view-btn {\r\n  background: #6c757d;\r\n  color: white;\r\n  border: none;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  width: 28px;\r\n  height: 28px;\r\n  flex-shrink: 0;\r\n  flex-grow: 0;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background 0.2s ease;\r\n}\r\n\r\n.back-btn:hover,\r\n.close-salary-view-btn:hover {\r\n  background: #5a6268;\r\n}\r\n\r\n/* 에러 컨테이너 */\r\n.error-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: var(--spacing-xl);\r\n  gap: var(--spacing-md);\r\n}\r\n\r\n/* 반응형 유틸리티 */\r\n@media (max-width: 768px) {\r\n  .btn {\r\n    padding: var(--spacing-sm);\r\n    font-size: var(--font-xs);\r\n  }\r\n  \r\n  .btn-lg {\r\n    padding: var(--spacing-sm) var(--spacing-md);\r\n    font-size: var(--font-sm);\r\n  }\r\n  \r\n  .card-body {\r\n    padding: var(--spacing-md);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
